import { t as gsapWithCSS } from "@theme/gsap";
import { r as refreshScrollTrigger } from "@theme/gsap-utils";
//#region frontend/islands/expandable-accordion.js
var ExpandableAccordion = class extends window.HTMLElement {
	connectedCallback() {
		this.button = this.querySelector("button");
		this.content = this.querySelector("[data-accordion-content=\"true\"]");
		this.icon = this.querySelector(".accordion-icon");
		if (this.button && this.content) {
			this.button.addEventListener("click", () => this.toggle());
			this.initializeHeight();
		}
	}
	initializeHeight() {
		if (this.button.getAttribute("aria-expanded") === "true") {
			this.content.style.height = "auto";
			this.content.style.overflow = "visible";
			this.icon.style.transform = "rotate(180deg)";
		} else {
			this.content.style.height = "0px";
			this.content.style.overflow = "hidden";
		}
	}
	toggle() {
		if (this.button.getAttribute("aria-expanded") === "true") this.close();
		else this.open();
	}
	open() {
		this.button.setAttribute("aria-expanded", "true");
		this.content.style.overflow = "hidden";
		gsapWithCSS.to(this.content, {
			height: this.content.scrollHeight,
			duration: .6,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => {
				this.content.style.height = "auto";
				this.content.style.overflow = "visible";
				refreshScrollTrigger();
			}
		});
		if (this.icon) gsapWithCSS.to(this.icon, {
			rotate: 180,
			duration: .5,
			ease: "power3.out",
			overwrite: "auto"
		});
	}
	close() {
		this.button.setAttribute("aria-expanded", "false");
		this.content.style.overflow = "hidden";
		gsapWithCSS.to(this.content, {
			height: 0,
			duration: .6,
			ease: "power3.out",
			overwrite: "auto",
			onComplete: () => refreshScrollTrigger()
		});
		if (this.icon) gsapWithCSS.to(this.icon, {
			rotate: 0,
			duration: .5,
			ease: "power3.out",
			overwrite: "auto"
		});
	}
};
window.customElements.define("expandable-accordion", ExpandableAccordion);
//#endregion
